// Inventario Extenso de Personalidad, Adaptabilidad y Escalas de Sinceridad UNINAV 2026
// Basado en los principios psicométricos de tamizaje militar (derivados MMPI / 16PF / PAI)
// Incorpora: 180 reactivos con Escala L (Mentira / Deseabilidad Social) y Pares de Consistencia Cruzada.

export const PERSONALITY_INVENTORY = [
  {
    "id": "per_01",
    "dimension": "DISCIPLINA",
    "statement": "Considero indispensable acatar las órdenes legítimas de mis mandos sin vacilación, incluso si personalmente no coinciden con mi criterio.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": "PAIR_DISC_1A"
  },
  {
    "id": "per_02",
    "dimension": "DISCIPLINA",
    "statement": "Las rutinas sumamente estrictas, las formaciones tempranas y los reglamentos minuciosos me brindan orden y claridad en mi vida diaria.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": "PAIR_DISC_2A"
  },
  {
    "id": "per_03",
    "dimension": "DISCIPLINA",
    "statement": "A veces me resulta molesto tener que pedir autorización para cosas sencillas que podría resolver por mi cuenta.",
    "direction": "NEGATIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_04",
    "dimension": "DISCIPLINA",
    "statement": "El respeto a la jerarquía y a los símbolos patrios es un principio que debe defenderse con convicción moral absoluta.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_05",
    "dimension": "VALIDEZ_L",
    "statement": "Nunca en toda mi vida he dicho una mentira, ni siquiera por cortesía o piedad.",
    "direction": "LIE_IF_TRUE",
    "lieScale": true,
    "pairId": null
  },
  {
    "id": "per_06",
    "dimension": "ESTABILIDAD",
    "statement": "Mantengo la calma y la capacidad de pensar con frialdad cuando me encuentro en situaciones imprevistas de peligro o presión.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": "PAIR_STRESS_1A"
  },
  {
    "id": "per_07",
    "dimension": "VALIDEZ_L",
    "statement": "Jamás he sentido envidia ni resentimiento por el éxito o los logros de otra persona.",
    "direction": "LIE_IF_TRUE",
    "lieScale": true,
    "pairId": null
  },
  {
    "id": "per_08",
    "dimension": "ESTABILIDAD",
    "statement": "Frecuentemente experimento cambios repentinos de humor que me cuesta trabajo comprender o controlar.",
    "direction": "NEGATIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_09",
    "dimension": "TRABAJO_EQUIPO",
    "statement": "Prefiero sacrificar mi beneficio o comodidad personal con tal de que mi dotación o equipo alcance el objetivo asignado.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": "PAIR_TEAM_1A"
  },
  {
    "id": "per_10",
    "dimension": "AUTOCONTROL",
    "statement": "Cuando alguien me contradice o me provoca abiertamente, soy capaz de mantener la serenidad sin recurrir a la agresividad verbal o física.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": "PAIR_TEMPLE_1A"
  },
  {
    "id": "per_11",
    "dimension": "VALIDEZ_L",
    "statement": "Nunca he llegado tarde a una cita ni he postergado una obligación escolar o laboral.",
    "direction": "LIE_IF_TRUE",
    "lieScale": true,
    "pairId": null
  },
  {
    "id": "per_12",
    "dimension": "RESILIENCIA",
    "statement": "Cuando cometo un error y recibo una llamada de atención severa, asimilo el aprendizaje rápidamente sin desmoralizarme.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": "PAIR_RESIL_1A"
  },
  {
    "id": "per_13",
    "dimension": "ADAPTABILIDAD",
    "statement": "Me adapto con facilidad a convivir en espacios reducidos con personas de costumbres muy diferentes a las mías.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": "PAIR_DIST_1A"
  },
  {
    "id": "per_14",
    "dimension": "VALIDEZ_L",
    "statement": "Jamás he sentido pereza o falta de ganas para levantarme por la mañana.",
    "direction": "LIE_IF_TRUE",
    "lieScale": true,
    "pairId": null
  },
  {
    "id": "per_15",
    "dimension": "AUTOCONTROL",
    "statement": "En ocasiones la frustración me ha llevado a golpear objetos o levantar la voz descontroladamente.",
    "direction": "NEGATIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_16",
    "dimension": "ESTABILIDAD",
    "statement": "Bajo presión extrema suelo bloquearme mentalmente y dudar sobre qué decisión tomar.",
    "direction": "NEGATIVE",
    "lieScale": false,
    "pairId": "PAIR_STRESS_1B"
  },
  {
    "id": "per_17",
    "dimension": "DISCIPLINA",
    "statement": "Pienso que antes de cumplir una orden dada por un superior, un cadete tiene derecho a debatirla si considera que hay un método mejor.",
    "direction": "NEGATIVE",
    "lieScale": false,
    "pairId": "PAIR_DISC_1B"
  },
  {
    "id": "per_18",
    "dimension": "TRABAJO_EQUIPO",
    "statement": "En el trabajo colectivo considero que cada quien debe velar por sus propios intereses y calificaciones individuales.",
    "direction": "NEGATIVE",
    "lieScale": false,
    "pairId": "PAIR_TEAM_1B"
  },
  {
    "id": "per_19",
    "dimension": "RESILIENCIA",
    "statement": "Las críticas fuertes sobre mi desempeño suelen hacerme dudar de mi capacidad durante varios días.",
    "direction": "NEGATIVE",
    "lieScale": false,
    "pairId": "PAIR_RESIL_1B"
  },
  {
    "id": "per_20",
    "dimension": "ADAPTABILIDAD",
    "statement": "Estar lejos de mi familia durante meses en navegaciones prolongadas me causaría una angustia insoportable.",
    "direction": "NEGATIVE",
    "lieScale": false,
    "pairId": "PAIR_DIST_1B"
  },
  {
    "id": "per_21",
    "dimension": "VALIDEZ_L",
    "statement": "Siempre he tenido pensamientos nobles y nunca he deseado el mal a nadie, ni siquiera en secreto.",
    "direction": "LIE_IF_TRUE",
    "lieScale": true,
    "pairId": null
  },
  {
    "id": "per_22",
    "dimension": "DISCIPLINA",
    "statement": "Disfruto el rigor militar, tener mi cama tendida al milímetro y las inspecciones de uniforme sin tolerancia a arrugas.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": "PAIR_DISC_2B"
  },
  {
    "id": "per_23",
    "dimension": "AUTOCONTROL",
    "statement": "Si un compañero me agrede de palabra, busco responderle de inmediato con la misma intensidad para no dejarme pisotear.",
    "direction": "NEGATIVE",
    "lieScale": false,
    "pairId": "PAIR_TEMPLE_1B"
  },
  {
    "id": "per_24",
    "dimension": "AUTOCONTROL",
    "statement": "Tengo un dominio férreo sobre mis reacciones y entiendo que la disciplina militar prohíbe las venganzas personales.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": "PAIR_TEMPLE_1C"
  },
  {
    "id": "per_25",
    "dimension": "VALIDEZ_L",
    "statement": "Nunca he leído nada indebido ni he hecho ningún comentario a espaldas de otra persona.",
    "direction": "LIE_IF_TRUE",
    "lieScale": true,
    "pairId": null
  },
  {
    "id": "per_26",
    "dimension": "ESTABILIDAD",
    "statement": "Estar en el mar abierto de noche o durante tormentas me genera una sensación de curiosidad profesional y respeto, no de terror paralizante.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_27",
    "dimension": "TRABAJO_EQUIPO",
    "statement": "La lealtad hacia mis compañeros de guardia es sagrada y jamás los abandonaría en una maniobra peligrosa.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_28",
    "dimension": "VALIDEZ_L",
    "statement": "Siempre digo exactamente lo que pienso con total sinceridad y jamás he fingido agrado por compromiso social.",
    "direction": "LIE_IF_TRUE",
    "lieScale": true,
    "pairId": null
  },
  {
    "id": "per_29",
    "dimension": "ESTABILIDAD",
    "statement": "Suelo dormir profundamente y conciliar el sueño con facilidad, aun en lugares extraños o ruidosos.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_30",
    "dimension": "DISCIPLINA",
    "statement": "El honor y el juramento militar a la Bandera Nacional son compromisos de vida que trascienden cualquier interés particular.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_31",
    "dimension": "DISCIPLINA",
    "statement": "Cumplo con entusiasmo las instrucciones aún cuando no esté presente ningún superior para supervisarme.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": "PAIR_DISC_3A"
  },
  {
    "id": "per_32",
    "dimension": "DISCIPLINA",
    "statement": "Considero que algunas reglas militares son obsoletas y deberían ignorarse si dificultan el trabajo rápido.",
    "direction": "NEGATIVE",
    "lieScale": false,
    "pairId": "PAIR_DISC_3B"
  },
  {
    "id": "per_33",
    "dimension": "DISCIPLINA",
    "statement": "Presentarme a tiempo a cualquier toque de campana o silbato es para mí una cuestión de dignidad marcial.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_34",
    "dimension": "DISCIPLINA",
    "statement": "Acepto las correcciones de un superior sin justificarme ni poner pretextos.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": "PAIR_CORR_1A"
  },
  {
    "id": "per_35",
    "dimension": "DISCIPLINA",
    "statement": "Cuando me señalan un error, suelo sentir la necesidad imperiosa de justificar por qué no fue mi culpa.",
    "direction": "NEGATIVE",
    "lieScale": false,
    "pairId": "PAIR_CORR_1B"
  },
  {
    "id": "per_36",
    "dimension": "DISCIPLINA",
    "statement": "La puntualidad estricta me parece una virtud esencial para la coordinación operativa de las fuerzas armadas.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_37",
    "dimension": "DISCIPLINA",
    "statement": "Si considero que un castigo disciplinario es injusto, buscaría la forma de desobedecerlo discretamente.",
    "direction": "NEGATIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_38",
    "dimension": "DISCIPLINA",
    "statement": "El uniforme militar merece un porte impecable tanto dentro como fuera de las instalaciones navales.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_39",
    "dimension": "DISCIPLINA",
    "statement": "Me incomoda que me digan exactamente a qué hora levantarme, asearme y comer.",
    "direction": "NEGATIVE",
    "lieScale": false,
    "pairId": "PAIR_ROUT_1A"
  },
  {
    "id": "per_40",
    "dimension": "DISCIPLINA",
    "statement": "Encuentro satisfacción en el orden meticuloso de las taquillas y pañoles navales.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": "PAIR_ROUT_1B"
  },
  {
    "id": "per_41",
    "dimension": "DISCIPLINA",
    "statement": "La cadena de mando debe respetarse rigurosamente en todas las circunstancias operativas.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_42",
    "dimension": "DISCIPLINA",
    "statement": "A veces he sentido el deseo de desafiar la autoridad de una persona que considero menos capaz que yo.",
    "direction": "NEGATIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_43",
    "dimension": "DISCIPLINA",
    "statement": "Estar en posición de firmes durante ceremonias prolongadas me permite ejercitar mi fuerza de voluntad.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_44",
    "dimension": "DISCIPLINA",
    "statement": "Prefiero actuar de forma espontánea que planificar cada detalle de mi jornada.",
    "direction": "NEGATIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_45",
    "dimension": "DISCIPLINA",
    "statement": "El saludo militar a un oficial superior es un símbolo de respeto institucional mutuo que ejecuto con orgullo.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_46",
    "dimension": "DISCIPLINA",
    "statement": "Si nadie me ve, tiendo a saltarme pasos en los protocolos de mantenimiento para terminar antes.",
    "direction": "NEGATIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_47",
    "dimension": "DISCIPLINA",
    "statement": "Comprendo y acepto que en la Universidad Naval la obediencia jerárquica es la base de la seguridad colectiva.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_48",
    "dimension": "DISCIPLINA",
    "statement": "Me molesta profundamente que personas más jóvenes con mayor jerarquía me den órdenes directas.",
    "direction": "NEGATIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_49",
    "dimension": "DISCIPLINA",
    "statement": "El aseo personal diario y el corte reglamentario son muestras del respeto que tengo por la institución militar.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_50",
    "dimension": "DISCIPLINA",
    "statement": "Considero que la disciplina debe ser voluntaria e interiorizada, no impuesta por temor a las sanciones.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_51",
    "dimension": "VALIDEZ_L",
    "statement": "Nunca en mi vida he sentido pereza para hacer algo que debía realizar de inmediato.",
    "direction": "LIE_IF_TRUE",
    "lieScale": true,
    "pairId": null
  },
  {
    "id": "per_52",
    "dimension": "VALIDEZ_L",
    "statement": "Jamás me ha molestado que alguien me gane en una competencia o juego.",
    "direction": "LIE_IF_TRUE",
    "lieScale": true,
    "pairId": null
  },
  {
    "id": "per_53",
    "dimension": "VALIDEZ_L",
    "statement": "Siempre cumplo al pie de la letra cualquier promesa que hago, sin excepción alguna.",
    "direction": "LIE_IF_TRUE",
    "lieScale": true,
    "pairId": null
  },
  {
    "id": "per_54",
    "dimension": "VALIDEZ_L",
    "statement": "Nunca he dicho una grosería ni he pronunciado palabras altisonantes en momentos de enojo.",
    "direction": "LIE_IF_TRUE",
    "lieScale": true,
    "pairId": null
  },
  {
    "id": "per_55",
    "dimension": "VALIDEZ_L",
    "statement": "Jamás he fingido estar enfermo para librarme de un compromiso o tarea desagradable.",
    "direction": "LIE_IF_TRUE",
    "lieScale": true,
    "pairId": null
  },
  {
    "id": "per_56",
    "dimension": "VALIDEZ_L",
    "statement": "Todas las personas que he conocido en mi vida me han caído perfectamente bien.",
    "direction": "LIE_IF_TRUE",
    "lieScale": true,
    "pairId": null
  },
  {
    "id": "per_57",
    "dimension": "VALIDEZ_L",
    "statement": "Nunca he sentido celos, envidia ni codicia por las posesiones de otros.",
    "direction": "LIE_IF_TRUE",
    "lieScale": true,
    "pairId": null
  },
  {
    "id": "per_58",
    "dimension": "VALIDEZ_L",
    "statement": "Jamás he sentido curiosidad por saber chismes o rumores de terceras personas.",
    "direction": "LIE_IF_TRUE",
    "lieScale": true,
    "pairId": null
  },
  {
    "id": "per_59",
    "dimension": "VALIDEZ_L",
    "statement": "Siempre mantengo una sonrisa en el rostro aun cuando las cosas no salgan como yo quiero.",
    "direction": "LIE_IF_TRUE",
    "lieScale": true,
    "pairId": null
  },
  {
    "id": "per_60",
    "dimension": "VALIDEZ_L",
    "statement": "Nunca he deseado que a un adversario le vaya mal en un examen o desafío.",
    "direction": "LIE_IF_TRUE",
    "lieScale": true,
    "pairId": null
  },
  {
    "id": "per_61",
    "dimension": "VALIDEZ_L",
    "statement": "Jamás he cometido una imprudencia ni he actuado sin pensar dos veces las consecuencias.",
    "direction": "LIE_IF_TRUE",
    "lieScale": true,
    "pairId": null
  },
  {
    "id": "per_62",
    "dimension": "VALIDEZ_L",
    "statement": "Nunca he comido más de lo necesario por gula o ansiedad.",
    "direction": "LIE_IF_TRUE",
    "lieScale": true,
    "pairId": null
  },
  {
    "id": "per_63",
    "dimension": "VALIDEZ_L",
    "statement": "Siempre tengo la paciencia suficiente para esperar a los demás sin desesperarme ni un segundo.",
    "direction": "LIE_IF_TRUE",
    "lieScale": true,
    "pairId": null
  },
  {
    "id": "per_64",
    "dimension": "VALIDEZ_L",
    "statement": "Jamás he sentido rencor o resentimiento hacia alguien que me ofendió en el pasado.",
    "direction": "LIE_IF_TRUE",
    "lieScale": true,
    "pairId": null
  },
  {
    "id": "per_65",
    "dimension": "VALIDEZ_L",
    "statement": "Nunca he presumido de algo que sé hacer bien para llamar la atención.",
    "direction": "LIE_IF_TRUE",
    "lieScale": true,
    "pairId": null
  },
  {
    "id": "per_66",
    "dimension": "VALIDEZ_L",
    "statement": "Siempre pongo los intereses de los demás por encima de los míos en el 100% de las ocasiones.",
    "direction": "LIE_IF_TRUE",
    "lieScale": true,
    "pairId": null
  },
  {
    "id": "per_67",
    "dimension": "VALIDEZ_L",
    "statement": "Jamás he sentido ganas de desquitarme con nadie cuando tengo un mal día.",
    "direction": "LIE_IF_TRUE",
    "lieScale": true,
    "pairId": null
  },
  {
    "id": "per_68",
    "dimension": "VALIDEZ_L",
    "statement": "Nunca he postergado una tarea aburrida para ver televisión o revisar redes sociales.",
    "direction": "LIE_IF_TRUE",
    "lieScale": true,
    "pairId": null
  },
  {
    "id": "per_69",
    "dimension": "VALIDEZ_L",
    "statement": "Siempre acepto las opiniones de los demás con total serenidad y sin juzgarlos jamás.",
    "direction": "LIE_IF_TRUE",
    "lieScale": true,
    "pairId": null
  },
  {
    "id": "per_70",
    "dimension": "VALIDEZ_L",
    "statement": "Nunca he tenido miedo a nada en mi vida, ni siquiera cuando era niño.",
    "direction": "LIE_IF_TRUE",
    "lieScale": true,
    "pairId": null
  },
  {
    "id": "per_71",
    "dimension": "ESTABILIDAD",
    "statement": "Tengo plena confianza en mi capacidad para superar situaciones de crisis o adversidad física extrema.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": "PAIR_CONF_1A"
  },
  {
    "id": "per_72",
    "dimension": "ESTABILIDAD",
    "statement": "Frecuentemente me asaltan dudas paralizantes sobre si seré capaz de soportar la exigencia física.",
    "direction": "NEGATIVE",
    "lieScale": false,
    "pairId": "PAIR_CONF_1B"
  },
  {
    "id": "per_73",
    "dimension": "ESTABILIDAD",
    "statement": "Puedo concentrarme con lucidez en mis deberes aun con ruidos de sirenas, alarmas o gritos de emergencia.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_74",
    "dimension": "ESTABILIDAD",
    "statement": "A menudo siento palpitaciones o sudoración fría en las manos cuando me enfrento a figuras de autoridad.",
    "direction": "NEGATIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_75",
    "dimension": "ESTABILIDAD",
    "statement": "Tengo un apetito regular y mi cuerpo asimila bien la comida incluso durante periodos de tensión.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_76",
    "dimension": "ESTABILIDAD",
    "statement": "A veces siento que mis nervios están al límite y que cualquier detalle insignificante me hace estallar.",
    "direction": "NEGATIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_77",
    "dimension": "ESTABILIDAD",
    "statement": "No padezco de claustrofobia ni me aterra permanecer en compartimentos cerrados y oscuros.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": "PAIR_PHOB_1A"
  },
  {
    "id": "per_78",
    "dimension": "ESTABILIDAD",
    "statement": "Estar en espacios reducidos bajo cubierta me genera una opresión en el pecho difícil de soportar.",
    "direction": "NEGATIVE",
    "lieScale": false,
    "pairId": "PAIR_PHOB_1B"
  },
  {
    "id": "per_79",
    "dimension": "ESTABILIDAD",
    "statement": "La vista de sangre o heridas graves no me provoca desmayos ni parálisis motriz.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_80",
    "dimension": "ESTABILIDAD",
    "statement": "En situaciones de zafarrancho de averías mantendría la mente fría para ejecutar el protocolo ordenado.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_81",
    "dimension": "ESTABILIDAD",
    "statement": "Tiendo a obsesionarme con los errores del pasado y me cuesta dejarlos atrás para avanzar.",
    "direction": "NEGATIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_82",
    "dimension": "ESTABILIDAD",
    "statement": "Me considero una persona emocionalmente estable, con buen humor constante y optimismo fundamentado.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_83",
    "dimension": "ESTABILIDAD",
    "statement": "Rara vez experimento estados de tristeza prolongada o desesperanza sin motivo aparente.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_84",
    "dimension": "ESTABILIDAD",
    "statement": "Cuando se acumulan muchas tareas bajo tiempo límite, priorizo con serenidad en lugar de angustiarme.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_85",
    "dimension": "ESTABILIDAD",
    "statement": "A veces me despierto en la noche con pesadillas y sensación de angustia o persecución.",
    "direction": "NEGATIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_86",
    "dimension": "ESTABILIDAD",
    "statement": "Confío en mi intuición y en mis reflejos para reaccionar ante una contingencia marina imprevista.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_87",
    "dimension": "ESTABILIDAD",
    "statement": "La soledad durante guardias nocturnas en cubierta me produce tranquilidad mental y agudiza mis sentidos.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_88",
    "dimension": "ESTABILIDAD",
    "statement": "Me afecta intensamente que otras personas me miren fijamente mientras realizo una maniobra práctica.",
    "direction": "NEGATIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_89",
    "dimension": "ESTABILIDAD",
    "statement": "Considero que tengo el temple necesario para afrontar una emergencia con riesgo real de vida.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_90",
    "dimension": "ESTABILIDAD",
    "statement": "Frecuentemente siento dolores de cabeza o malestar estomacal cuando me exigen resultados rápidos.",
    "direction": "NEGATIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_91",
    "dimension": "ESTABILIDAD",
    "statement": "No me perturba la presencia de oleaje fuerte ni las sacudidas bruscas de una embarcación en la mar.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_92",
    "dimension": "ESTABILIDAD",
    "statement": "Sé reconocer mis límites físicos sin poner en riesgo la seguridad de mis compañeros de maniobra.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_93",
    "dimension": "ESTABILIDAD",
    "statement": "Me recupero con rapidez de las malas noticias y enfoco mis energías en la solución inmediata.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_94",
    "dimension": "ESTABILIDAD",
    "statement": "En momentos de gran presión suelo sentir que pierdo el control de mis propios pensamientos.",
    "direction": "NEGATIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_95",
    "dimension": "ESTABILIDAD",
    "statement": "Mi pulso se mantiene firme al disparar en polígono o manipular instrumentos delicados de navegación.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_96",
    "dimension": "AUTOCONTROL",
    "statement": "Puedo escuchar insultos directos hacia mi persona sin perder la compostura marcial ni recurrir a los golpes.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": "PAIR_IRA_1A"
  },
  {
    "id": "per_97",
    "dimension": "AUTOCONTROL",
    "statement": "Si alguien me empuja o me reta con la mirada, mi primera reacción física es defenderme atacando.",
    "direction": "NEGATIVE",
    "lieScale": false,
    "pairId": "PAIR_IRA_1B"
  },
  {
    "id": "per_98",
    "dimension": "AUTOCONTROL",
    "statement": "Entiendo que el uso legítimo de la fuerza militar está subordinado a las leyes y órdenes superiores, no al enojo personal.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_99",
    "dimension": "AUTOCONTROL",
    "statement": "A veces guardo rencor durante semanas esperando el momento oportuno para cobrar una ofensa.",
    "direction": "NEGATIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_100",
    "dimension": "AUTOCONTROL",
    "statement": "Controlo mis deseos de gritar o protestar cuando recibo una indicación estricta que considero pesada.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_101",
    "dimension": "AUTOCONTROL",
    "statement": "Tengo facilidad para disculparme de corazón si reconozco que me excedí con un compañero.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_102",
    "dimension": "AUTOCONTROL",
    "statement": "En ocasiones me enojo con tanta intensidad que digo cosas hirientes de las cuales me arrepiento después.",
    "direction": "NEGATIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_103",
    "dimension": "AUTOCONTROL",
    "statement": "Canalizo la tensión física a través del ejercicio extenuante en lugar de desahogarme con la gente.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_104",
    "dimension": "AUTOCONTROL",
    "statement": "Sé guardar silencio y mantener la disciplina militar aun cuando la razón esté de mi lado.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_105",
    "dimension": "AUTOCONTROL",
    "statement": "Me resulta muy difícil obedecer a una persona que considero injusta o prepotente.",
    "direction": "NEGATIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_106",
    "dimension": "AUTOCONTROL",
    "statement": "Jamás recurriría a la violencia física para imponer mi liderazgo o ganar el respeto de mis subordinados.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_107",
    "dimension": "AUTOCONTROL",
    "statement": "Cuando un plan fracasa por culpa de otro, mi primera reacción es culparlo airadamente.",
    "direction": "NEGATIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_108",
    "dimension": "AUTOCONTROL",
    "statement": "Tengo la madurez para dialogar sobre desacuerdos sin alterarme ni tomarlo como un ataque personal.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_109",
    "dimension": "AUTOCONTROL",
    "statement": "Si un superior me reprende severamente de manera injusta, sé mantener la vista al frente y acatar sin retar con gestos.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_110",
    "dimension": "AUTOCONTROL",
    "statement": "A veces siento un impulso incontrolable de romper cosas cuando las computadoras o máquinas fallan.",
    "direction": "NEGATIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_111",
    "dimension": "AUTOCONTROL",
    "statement": "Trato con el mismo respeto y ecuanimidad al personal de intendencia que a los oficiales de alta jerarquía.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_112",
    "dimension": "AUTOCONTROL",
    "statement": "Reconozco que la compostura marcial es una demostración de superioridad moral ante la provocación.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_113",
    "dimension": "AUTOCONTROL",
    "statement": "En una riña callejera donde esté involucrado un compañero de armas, intervendría para separarlos y no para golpear.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_114",
    "dimension": "AUTOCONTROL",
    "statement": "Tengo pleno dominio sobre mis impulsos de apostar, fumar o consumir sustancias que nublen mi juicio.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_115",
    "dimension": "AUTOCONTROL",
    "statement": "Acepto perder en una justa deportiva militar felicitando con sinceridad al vencedor.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_116",
    "dimension": "AUTOCONTROL",
    "statement": "Si veo a un compañero cometer una falta menor, prefiero aconsejarlo en privado que exhibirlo públicamente.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_117",
    "dimension": "AUTOCONTROL",
    "statement": "Me molesta cuando un grupo no sigue mis sugerencias y prefiero apartarme para que se equivoquen solos.",
    "direction": "NEGATIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_118",
    "dimension": "AUTOCONTROL",
    "statement": "Entiendo que un oficial naval que pierde la paciencia pone en riesgo la vida de su tripulación.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_119",
    "dimension": "AUTOCONTROL",
    "statement": "Sé modular mi voz para transmitir firmeza y autoridad sin necesidad de gritar desesperadamente.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_120",
    "dimension": "AUTOCONTROL",
    "statement": "La paciencia ante la rutina prolongada es una fortaleza que he desarrollado con el tiempo.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_121",
    "dimension": "TRABAJO_EQUIPO",
    "statement": "La fraternidad y la unión incondicional con mis compañeros de generación son primordiales para mí.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": "PAIR_FRAT_1A"
  },
  {
    "id": "per_122",
    "dimension": "TRABAJO_EQUIPO",
    "statement": "Prefiero trabajar de manera individual porque no confío en que los demás hagan las cosas bien.",
    "direction": "NEGATIVE",
    "lieScale": false,
    "pairId": "PAIR_FRAT_1B"
  },
  {
    "id": "per_123",
    "dimension": "TRABAJO_EQUIPO",
    "statement": "Si veo a un compañero rezagarse durante la carrera de acondicionamiento, lo animo y reduzco el paso para empujarlo.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_124",
    "dimension": "TRABAJO_EQUIPO",
    "statement": "En una tarea comunitaria me limito a cumplir mi parte estricta sin preocuparme si el resto termina.",
    "direction": "NEGATIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_125",
    "dimension": "TRABAJO_EQUIPO",
    "statement": "Siento un orgullo genuino cuando un compañero de mi brigada recibe una felicitación por mérito.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_126",
    "dimension": "TRABAJO_EQUIPO",
    "statement": "Me desagrada compartir mis alimentos o pertenencias con personas que apenas conozco.",
    "direction": "NEGATIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_127",
    "dimension": "TRABAJO_EQUIPO",
    "statement": "Entiendo que en un barco o patrulla naval el error de uno afecta la supervivencia de todos.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_128",
    "dimension": "TRABAJO_EQUIPO",
    "statement": "Si mi pelotón es sancionado por la falta de un solo elemento, asumo la sanción solidaria sin rencor hacia él.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": "PAIR_CAST_1A"
  },
  {
    "id": "per_129",
    "dimension": "TRABAJO_EQUIPO",
    "statement": "Si sancionan a todo el grupo por culpa de un compañero descuidado, exijo que solo se castigue al culpable.",
    "direction": "NEGATIVE",
    "lieScale": false,
    "pairId": "PAIR_CAST_1B"
  },
  {
    "id": "per_130",
    "dimension": "TRABAJO_EQUIPO",
    "statement": "Tengo facilidad para coordinar actividades con compañeros de diferentes procedencias sociales y culturales.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_131",
    "dimension": "TRABAJO_EQUIPO",
    "statement": "Prefiero que el mérito de una misión exitosa se atribuya al equipo completo antes que a mi persona sola.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_132",
    "dimension": "TRABAJO_EQUIPO",
    "statement": "Me cuesta trabajo obedecer las instrucciones de un cadete de mi misma edad cuando le asignan el mando.",
    "direction": "NEGATIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_133",
    "dimension": "TRABAJO_EQUIPO",
    "statement": "Estoy dispuesto a prestar mi equipo de protección o abrigo a un compañero que esté pasando frío o peligro.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_134",
    "dimension": "TRABAJO_EQUIPO",
    "statement": "La cohesión de la unidad militar es para mí una coraza que hace invencible a la dotación.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_135",
    "dimension": "TRABAJO_EQUIPO",
    "statement": "Suelo notar de inmediato cuando un camarada de brigada está deprimido o angustiado y busco apoyarlo.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_136",
    "dimension": "TRABAJO_EQUIPO",
    "statement": "Me gusta competir intensamente contra otros escuadrones fomentando el espíritu de sana emulación.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_137",
    "dimension": "TRABAJO_EQUIPO",
    "statement": "En una balsa salvavidas cedería mi ración de abrigo a un elemento herido o de mayor vulnerabilidad.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_138",
    "dimension": "TRABAJO_EQUIPO",
    "statement": "Creo firmemente que la confianza mutua es el cimiento de cualquier tripulación de combate naval.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_139",
    "dimension": "TRABAJO_EQUIPO",
    "statement": "A veces prefiero ocultar mis ideas en el grupo para no comprometerme con responsabilidades extras.",
    "direction": "NEGATIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_140",
    "dimension": "TRABAJO_EQUIPO",
    "statement": "Compartir las alegrías y las fatigas del adiestramiento crea vínculos que duran toda la vida.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_141",
    "dimension": "TRABAJO_EQUIPO",
    "statement": "Entiendo que el compañerismo verdadero no significa encubrir delitos ni faltas que manchen el uniforme.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_142",
    "dimension": "TRABAJO_EQUIPO",
    "statement": "Me siento motivado cuando una meta difícil se alcanza gracias a la sincronización de varios elementos.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_143",
    "dimension": "TRABAJO_EQUIPO",
    "statement": "Tengo paciencia para enseñarle técnicas de amarre o nudos a los compañeros que tienen mayor dificultad motriz.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_144",
    "dimension": "TRABAJO_EQUIPO",
    "statement": "Desconfío de las intenciones de los compañeros que son demasiado amables conmigo.",
    "direction": "NEGATIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_145",
    "dimension": "TRABAJO_EQUIPO",
    "statement": "El lema 'En el mar, la unión es vida' resume con exactitud mi convicción de servicio.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_146",
    "dimension": "RESILIENCIA",
    "statement": "El dolor físico por ampollas o cansancio muscular no disminuye mi resolución de alcanzar la meta.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_147",
    "dimension": "RESILIENCIA",
    "statement": "Si las condiciones meteorológicas son adversas (lluvia, frío intenso, sol canicular), mantengo el mismo rendimiento.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_148",
    "dimension": "RESILIENCIA",
    "statement": "Cuando repruebo una práctica importante, dedico las horas libres a entrenar hasta dominarla con creces.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_149",
    "dimension": "RESILIENCIA",
    "statement": "Me desmotivo con facilidad cuando veo que otros avanzan más rápido que yo con menos esfuerzo.",
    "direction": "NEGATIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_150",
    "dimension": "RESILIENCIA",
    "statement": "Entiendo que el adiestramiento naval militar está diseñado deliberadamente para poner a prueba mi límite.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_151",
    "dimension": "ADAPTABILIDAD",
    "statement": "Dormir en coy o litera estrecha con el movimiento continuo del mar me resulta una experiencia agradable.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_152",
    "dimension": "ADAPTABILIDAD",
    "statement": "Tengo capacidad para acostumbrarme a comer raciones de campaña o rancho militar sin quejarme por el sazón.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_153",
    "dimension": "ADAPTABILIDAD",
    "statement": "La falta de comunicación telefónica o acceso a internet durante semanas en navegación es algo que acepto con naturalidad.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": "PAIR_NET_1A"
  },
  {
    "id": "per_154",
    "dimension": "ADAPTABILIDAD",
    "statement": "Estar desconectado de mi teléfono celular y redes sociales por más de 48 horas me produce una fuerte ansiedad.",
    "direction": "NEGATIVE",
    "lieScale": false,
    "pairId": "PAIR_NET_1B"
  },
  {
    "id": "per_155",
    "dimension": "ADAPTABILIDAD",
    "statement": "Respeto los horarios de silencio estricto en los dormitorios navales sin hacer ruido que moleste a los que duermen.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_156",
    "dimension": "ADAPTABILIDAD",
    "statement": "Me adapto rápidamente a los cambios repentinos de rol o comisiones imprevistas durante la guardia.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_157",
    "dimension": "ADAPTABILIDAD",
    "statement": "Siento que el ambiente marítimo, el olor a salitre y la disciplina militar encajan perfectamente con mi vocación.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_158",
    "dimension": "RESILIENCIA",
    "statement": "He superado dificultades personales severas en el pasado gracias a mi tenacidad y fe en mí mismo.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_159",
    "dimension": "RESILIENCIA",
    "statement": "Afronto los exámenes de admisión con determinación, sin dejarme vencer por los nervios de la competencia.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_160",
    "dimension": "RESILIENCIA",
    "statement": "Si caigo al agua con uniforme completo, mantengo la calma y aplico las técnicas de flotación militar.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_161",
    "dimension": "ADAPTABILIDAD",
    "statement": "Me parece estimulante la posibilidad de viajar a puertos extranjeros y convivir con marinos de otras naciones.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_162",
    "dimension": "ADAPTABILIDAD",
    "statement": "Estar mojado durante varias horas en una práctica no me hace abandonar la línea de fuego ni la formación.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_163",
    "dimension": "RESILIENCIA",
    "statement": "Considero que las dificultades y los sacrificios forjan el carácter de los mejores oficiales de la Armada.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_164",
    "dimension": "ADAPTABILIDAD",
    "statement": "Puedo pasar de un estado de sueño profundo a estar plenamente alerta y uniformado en cuestión de dos minutos.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_165",
    "dimension": "RESILIENCIA",
    "statement": "Mi deseo de portar el sable de oficial de la Armada de México es más fuerte que cualquier obstáculo terrenal.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_166",
    "dimension": "ETICA_HONOR",
    "statement": "La verdad debe defenderse aun cuando decirla implique una sanción directa para mí.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": "PAIR_VER_1A"
  },
  {
    "id": "per_167",
    "dimension": "ETICA_HONOR",
    "statement": "Considero válido encubrir una falta grave de un compañero con tal de que no lo den de baja de la escuela.",
    "direction": "NEGATIVE",
    "lieScale": false,
    "pairId": "PAIR_VER_1B"
  },
  {
    "id": "per_168",
    "dimension": "ETICA_HONOR",
    "statement": "El robo de cualquier prenda o material militar, por mínimo que sea, es una traición al honor de la escuela.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_169",
    "dimension": "ETICA_HONOR",
    "statement": "Jamás aceptaría dinero, regalos o favores a cambio de conceder ventajas en una guardia o trámite.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_170",
    "dimension": "ETICA_HONOR",
    "statement": "El respeto a los derechos humanos y a la dignidad de toda persona es un principio inquebrantable de mi conducta.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_171",
    "dimension": "ETICA_HONOR",
    "statement": "Siento un profundo respeto por los héroes navales que ofrendaron su vida en defensa de la Patria en Veracruz.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_172",
    "dimension": "ETICA_HONOR",
    "statement": "Si un superior me ordenara realizar una acción manifiestamente contraria a la ley o a la ética, sabría acudir al mando correspondiente.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_173",
    "dimension": "ETICA_HONOR",
    "statement": "Considero que la palabra de un oficial de marina debe tener más valor y peso que un documento firmado.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_174",
    "dimension": "ETICA_HONOR",
    "statement": "Cuidaría las armas y pertrechos que la Nación pone en mis manos con la máxima devoción y rigor.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_175",
    "dimension": "ETICA_HONOR",
    "statement": "Nunca divulgaría información sensible sobre operaciones o buques de la Armada a personas ajenas a la institución.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_176",
    "dimension": "ETICA_HONOR",
    "statement": "La vocación de servir a México en el mar es el sueño profesional más importante de mi existencia.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_177",
    "dimension": "ETICA_HONOR",
    "statement": "Si presenciara un acto de corrupción dentro de la unidad, lo reportaría formalmente por el conducto regular.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_178",
    "dimension": "ETICA_HONOR",
    "statement": "Entiendo que el uniforme de la Heroica Escuela Naval Militar es un manto de honor que exige rectitud intachable.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_179",
    "dimension": "ETICA_HONOR",
    "statement": "Prefiero causar baja por honestidad antes que permanecer en la institución mediante el engaño y la falsificación.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  },
  {
    "id": "per_180",
    "dimension": "ETICA_HONOR",
    "statement": "Me comprometo solemnemente a dar lo mejor de mis capacidades físicas e intelectuales durante mi formación militar naval.",
    "direction": "POSITIVE",
    "lieScale": false,
    "pairId": null
  }
];

// Opciones de respuesta para el Inventario de Personalidad
export const PERSONALITY_OPTIONS = [
  { value: "V", label: "Verdadero", sublabel: "Describe mi conducta o forma de pensar habitual" },
  { value: "F", label: "Falso", sublabel: "No coincide con mi comportamiento o actitud real" }
];

// Definición de Pares de Consistencia para Auditoría de Sinceridad
export const CONSISTENCY_PAIRS = [
  {
    "id": "PAIR_DISC_1",
    "itemA": "per_01",
    "itemB": "per_17",
    "expectedConsistent": {
      "itemA": "V",
      "itemB": "F"
    },
    "concept": "Acatamiento de órdenes jerárquicas vs debate de normas"
  },
  {
    "id": "PAIR_STRESS_1",
    "itemA": "per_06",
    "itemB": "per_16",
    "expectedConsistent": {
      "itemA": "V",
      "itemB": "F"
    },
    "concept": "Control bajo presión vs bloqueo mental en emergencia"
  },
  {
    "id": "PAIR_TEAM_1",
    "itemA": "per_09",
    "itemB": "per_18",
    "expectedConsistent": {
      "itemA": "V",
      "itemB": "F"
    },
    "concept": "Trabajo en equipo y sacrificio colectivo vs individualismo"
  },
  {
    "id": "PAIR_RESIL_1",
    "itemA": "per_12",
    "itemB": "per_19",
    "expectedConsistent": {
      "itemA": "V",
      "itemB": "F"
    },
    "concept": "Sobreponerse a regaños y errores vs desánimo prolongado"
  },
  {
    "id": "PAIR_DIST_1",
    "itemA": "per_13",
    "itemB": "per_20",
    "expectedConsistent": {
      "itemA": "V",
      "itemB": "F"
    },
    "concept": "Disposición al internado naval vs angustia por separación familiar"
  },
  {
    "id": "PAIR_DISC_2",
    "itemA": "per_02",
    "itemB": "per_22",
    "expectedConsistent": {
      "itemA": "V",
      "itemB": "V"
    },
    "concept": "Aprecio por rutinas estrictas y adaptación a dormitorios y horarios"
  },
  {
    "id": "PAIR_TEMPLE_1",
    "itemA": "per_23",
    "itemB": "per_24",
    "expectedConsistent": {
      "itemA": "V",
      "itemB": "F"
    },
    "concept": "Autocontrol ante provocaciones vs respuesta impulsiva"
  },
  {
    "id": "PAIR_DISC_3",
    "itemA": "per_31",
    "itemB": "per_32",
    "expectedConsistent": {
      "itemA": "V",
      "itemB": "F"
    },
    "concept": "Acatamiento autónomo vs ignorar reglas por rapidez"
  },
  {
    "id": "PAIR_CORR_1",
    "itemA": "per_34",
    "itemB": "per_35",
    "expectedConsistent": {
      "itemA": "V",
      "itemB": "F"
    },
    "concept": "Asimilación madura de correcciones vs poner pretextos"
  },
  {
    "id": "PAIR_ROUT_1",
    "itemA": "per_39",
    "itemB": "per_40",
    "expectedConsistent": {
      "itemA": "F",
      "itemB": "V"
    },
    "concept": "Aceptación de horarios estrictos vs orden de pañoles"
  },
  {
    "id": "PAIR_CONF_1",
    "itemA": "per_71",
    "itemB": "per_72",
    "expectedConsistent": {
      "itemA": "V",
      "itemB": "F"
    },
    "concept": "Confianza en rendimiento físico vs dudas paralizantes"
  },
  {
    "id": "PAIR_PHOB_1",
    "itemA": "per_77",
    "itemB": "per_78",
    "expectedConsistent": {
      "itemA": "V",
      "itemB": "F"
    },
    "concept": "Ausencia de claustrofobia en pañoles vs opresión en espacios cerrados"
  },
  {
    "id": "PAIR_IRA_1",
    "itemA": "per_96",
    "itemB": "per_97",
    "expectedConsistent": {
      "itemA": "V",
      "itemB": "F"
    },
    "concept": "Compostura ante insultos vs agresión física inmediata"
  },
  {
    "id": "PAIR_FRAT_1",
    "itemA": "per_121",
    "itemB": "per_122",
    "expectedConsistent": {
      "itemA": "V",
      "itemB": "F"
    },
    "concept": "Fraternidad y espíritu de cuerpo vs individualismo desconfiado"
  },
  {
    "id": "PAIR_CAST_1",
    "itemA": "per_128",
    "itemB": "per_129",
    "expectedConsistent": {
      "itemA": "V",
      "itemB": "F"
    },
    "concept": "Aceptación de sanción solidaria vs individualismo ante castigo colectivo"
  },
  {
    "id": "PAIR_NET_1",
    "itemA": "per_153",
    "itemB": "per_154",
    "expectedConsistent": {
      "itemA": "V",
      "itemB": "F"
    },
    "concept": "Aceptación de desconexión en alta mar vs angustia sin celular"
  },
  {
    "id": "PAIR_VER_1",
    "itemA": "per_166",
    "itemB": "per_167",
    "expectedConsistent": {
      "itemA": "V",
      "itemB": "F"
    },
    "concept": "Defender la verdad a ultranza vs encubrir faltas graves por complicidad"
  }
];
